import API from "./api";

export async function fetchAllTools() {
  const response = await API.get("/api/admin/tools?show_all=true");
  return response.data;
}

export async function setToolEnabled(toolId, enabled) {
  const response = await API.put(`/api/admin/tools/${toolId}`, { enabled });
  return response.data;
}

export async function addTool(payload) {
  const response = await API.post("/api/admin/tools", payload);
  return response.data;
}

export async function deleteTool(toolId) {
  const response = await API.delete(`/api/admin/tools/${toolId}`);
  return response.data;
}
